'use client';
import {
  useFetchUserFeed,
  useHomeFeedFilters,
  useResetFeedCache,
} from '@/actions/feed.actions';
import Post from '@components/Post';
import Spinner from '@components/Spinner';
import Typography from '@ui/Typography';
import { size } from 'lodash-es';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

function Posts(props) {
  const { initialPosts } = props;

  const [seededPosts, setSeededPosts] = React.useState(initialPosts || []);
  const postType = useHomeFeedFilters((state) => state.postType);
  const filters = useHomeFeedFilters((state) => state.filters);
  const resetFeedCache = useResetFeedCache();
  const {
    data,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useFetchUserFeed(postType, seededPosts, filters);

  React.useEffect(() => {
    if (postType !== 'all') {
      setSeededPosts(undefined);
    }

    resetFeedCache();
    refetch();
  }, [postType, filters]);

  const totalPostsCached =
    data?.pages.reduce((acc, group) => acc + size(group.posts), 0) || 0;

  const handleLoadNextPage = async () => {
    if (!isFetchingNextPage && hasNextPage) {
      return fetchNextPage();
    }
    return [];
  };

  return (
    <InfiniteScroll
      dataLength={totalPostsCached}
      next={handleLoadNextPage}
      hasMore={hasNextPage || isFetchingNextPage || isLoading}
      loader={
        <div className="relative flex w-full items-center justify-center p-2">
          <Spinner className="h-8 w-8 text-primary" />
        </div>
      }
      endMessage={
        <div className="flex items-center justify-center p-2">
          <Typography variant="body1" color="textDisabled">
            There are no more posts to show right now.
          </Typography>
        </div>
      }>
      <div className="relative z-0 flex w-full flex-col gap-2.5">
        {data?.pages.map((group, pageIndex) => (
          <React.Fragment key={pageIndex}>
            {group.posts.map((post, postIndex) => (
              <Post
                key={post.id}
                post={post}
                home
                // hack for ensuring comments menu is rendered on top of the next post card
                style={{
                  zIndex: -(pageIndex * group.posts.length + postIndex),
                }}
              />
            ))}
          </React.Fragment>
        ))}
      </div>
    </InfiniteScroll>
  );
}

export default Posts;
